module.exports = __webpack_public_path__ + "static/media/08.d9a47928.mp3";